import PropTypes from 'prop-types';
import React from 'react';
import createReactClass from 'create-react-class';
import Checkbox from 'views/ui/form_elements/checkbox';
import FormControllerProxy from 'lib/form/controller_proxy';
import classnames from 'classnames';
import ModalActionCreator from 'action_creators/modal';

import './index.scss';

export default createReactClass({
  displayName: 'CheckoutWaiver',
  mixins: [FormControllerProxy],

  propTypes: {
    fields: PropTypes.object,
    errors: PropTypes.object,
    label: PropTypes.string,
    name: PropTypes.string,
    content: PropTypes.string,
    onClick: PropTypes.func,
  },

  _clickedWaiverLink(e) {
    e.preventDefault();
    ModalActionCreator.show({
      content: this._modalContent(),
      triggeringElement: e.currentTarget,
      className: 'small Waiver-Modal',
    });
  },

  _closeModal(e) {
    e.preventDefault();
    ModalActionCreator.hide();
  },

  _modalContent() {
    return (
      <div className="CheckoutWaiver-Modal-content">
        <div dangerouslySetInnerHTML={{ __html: this.props.content }} />
      </div>
    );
  },

  render() {
    const containerClasses = classnames('CheckoutWaiver', {
      'no-bottom-border': !!this.props.borderless,
    });

    return (
      <div className={containerClasses}>
        <Checkbox
          {...this._formProps('waiver_accepted')}
          dataTestProp="waiver-policy-checkbox"
        >
          <span data-testid="waiver-label">{this.props.label}</span>{' '}
          <a
            href="#"
            className="brand-color"
            data-testid="waiver-link"
            onClick={this._clickedWaiverLink}
          >
            {this.props.name}
          </a>
        </Checkbox>
      </div>
    );
  },
});
